module.exports = __webpack_public_path__ + "media/deny5.40082957.webm";